module.exports = __webpack_public_path__ + "img/265-william_shakespeare_quotes.6a943ba0.jpeg";